module.exports = __webpack_public_path__ + "static/media/logo_yandeh_orange.1eff08e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_yandeh_orange.png
// module id = 1279
// module chunks = 0